export const ACTION_USER_ADD = 'ACTION_USER_ADD'
export const ACTION_USER_LIST = 'ACTION_USER_LIST'
export const ACTION_USER_LIST_FAIL = 'ACTION_USER_LIST_FAIL'
export const ACTION_USER_UPDATE = 'ACTION_USER_UPDATE';
export const ACTION_USER_SET_CURRENT = 'ACTION_USER_SET_CURRENT';
export const ACTION_USER_NEWSLETTER_LIST = "ACTION_USER_NEWSLETTER_LIST";
export const ACTION_USER_NEWSLETTER_LIST_FAIL = "ACTION_USER_NEWSLETTER_LIST_FAIL";